'use client';

import React from 'react';
import { cn } from '@/app/lib/utils';
import { FooterLogo, FooterColumns, FooterContact, FooterBottom } from './ui';
import { useFooter } from './lib';
import { processFooterColumns, processContactInfo, processLegalInfo } from './lib/footer.utils';
import type { FooterData } from './interfaces';

interface FooterProps {
  className?: string;
}

export function Footer({ className = '' }: FooterProps) {
  const { footerData } = useFooter();
  const typedFooter = footerData as FooterData;

  const columns = processFooterColumns(typedFooter?.footerColums);
  const contactInfo = processContactInfo(typedFooter?.footerContact);
  const legalProps = processLegalInfo(typedFooter?.legalInfo);

  return (
    <footer className={cn('bg-accent w-full relative', className)}>
      {/* <div className="absolute -top-16 right-6 md:right-[150px] z-20">
        <AskGreq />
      </div> */}
      <div className="porta-container px-md md:px-4xl md:pt-4xl md:pb-md-banner py-2xl">
        <div className="grid grid-cols-1 gap-y-3xl md:grid-cols-[auto_1fr_auto] md:gap-y-0">
          {/* Logo */}
          <div className="hidden md:block">
            <FooterLogo
              imageUrl={typedFooter?.footerLogo?.imageUrl}
              title={typedFooter?.footerLogo?.title}
              link={typedFooter?.footerLogo?.link}
            />
          </div>

          {/* Columns */}
          <div className="md:min-w-0 md:ml-gutter footer:ml-4xl">
            <FooterColumns columns={columns} />
          </div>

          {/* Contact */}
          <div className="md:justify-self-end md:ml-gutter footer:ml-3xl">
            <FooterContact contactInfo={contactInfo} socialLinks={[]} footerSocialLinks={typedFooter?.socialLinks} />
          </div>
        </div>
      </div>

      <FooterBottom
        copyrightText={legalProps.copyrightText}
        additionalText={legalProps.additionalText}
        legalLinks={legalProps.legalLinks}
      />
    </footer>
  );
}
